import type { TagContext, Tagger, Tags } from "@ihr-radioedit/inferno-core";

export const podcastTags: Tagger = (state: Tags, context: TagContext) => {
  state.surrogateKeys.add(`podcasts/${context.site.index.slug}`);
  return state;
};
